import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import "./CartFloatingButton.css";

function CartFloatingButton() {
  const { cartItems, setCartOpen, cartOpen } = useCart();
  const { user } = useAuth();

  // Only show the cart button to logged-in users
  if (!user) return null;

  return (
    <button
      className={`cart-floating-btn${cartOpen ? " cart-floating-btn--hidden" : ""}`}
      onClick={() => setCartOpen(true)}
      aria-label="Open cart"
      title="View Cart"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="9" cy="21" r="1" />
        <circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
      </svg>

      {cartItems.length > 0 && (
        <span className="cart-float-badge">{cartItems.length}</span>
      )}
    </button>
  );
}

export default CartFloatingButton;
